import HomePageContent from '../components/homepage/HomePageApp';

const HomeApp = () => {
  return <HomePageContent />;
};

export default HomeApp;